import React from 'react'
import { ratingListLabel } from 'keys/rating'
import { NotificationsNone } from '@mui/icons-material'
import { secretStorage } from 'config'
import { Chip } from 'components/Form'

const HasWarningCell = (props) => {
    const { row } = props
    const { battery_hidden } = row.original

    let avg = row.original?.wcpm_fluency_avg_rating_index

    const isSuperuser = secretStorage.getItem("user")?.is_superuser
    const batteryHidden = !isSuperuser && battery_hidden

    let item

    if (avg > 2.5)
        if (avg <= 3.5)
            item = "rating3"
        else if (avg > 3.5 && avg <= 4.5)
            item = "rating4"
        else
            item = "rating5"

    return (
        !item || batteryHidden ||
        <Chip
            color={item}
            type="icon"
            size="small"
            tooltip={`ממוצע ${ratingListLabel[avg.toFixed() - 1]}`}>
            <NotificationsNone fontSize='small' />
        </Chip>
    )
}

export default HasWarningCell